/*
  Establishment Category types
*/
export const establishmentCategories = [
  'HOSPITAL',
  'LABORATORY',
  'EMERGENCY_UNITY',
  'MATERNITY',
  'SPECIALIST'
] as const

export type EstablishmentCategory = (typeof establishmentCategories)[number]

/*
  Modalidade de atendimento do prestador. Transcrito do enum
  ConsolidatedAccreditedNetworkAppointmentType do servico de rede credenciada.
  Serve tanto como atributo do estabelecimento na resposta quanto como valor do
  filtro `appointmentType` na busca.
*/
export const appointmentTypes = ['PRESENTIAL', 'REMOTE'] as const

export type AppointmentType = (typeof appointmentTypes)[number]

/*
  Balde de genero aceito pela busca. Nao e o enum `Gender` do backend: sao tres
  baldes que particionam a populacao, e `OTHERS` e definido por exclusao de
  MALE e FEMALE. Transcrito de AccreditedGenderFilter (atlas-domain-client).
*/
export const accreditedGenders = ['FEMALE', 'MALE', 'OTHERS'] as const

export type AccreditedGender = (typeof accreditedGenders)[number]
